var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 37"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 4,
    cy: 24,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 44,
    cy: 24,
    r: 4,
    fill: "#626262",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28_2",
    cx: 24,
    cy: 4,
    r: 4,
    fill: "#626262",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29_2",
    cx: 24,
    cy: 44,
    r: 4,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28_3",
    cx: 38.1421,
    cy: 9.85778,
    r: 4,
    transform: "rotate(45 38.1421 9.85778)",
    fill: "#626262",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29_3",
    cx: 9.85791,
    cy: 38.1422,
    r: 4,
    transform: "rotate(45 9.85791 38.1422)",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28_4",
    cx: 38.142,
    cy: 38.1421,
    r: 4,
    transform: "rotate(135 38.142 38.1421)",
    fill: "#626262",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29_4",
    cx: 9.85779,
    cy: 9.85791,
    r: 4,
    transform: "rotate(135 9.85779 9.85791)",
    fill: "#626262",
    fillOpacity: 0.24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.c47bd3f5a161163a3a9a68152e538709.svg";
export { ForwardRef as ReactComponent };